import { useEffect, useState } from 'react';

import { KONCERTY_API_URL } from '../config/koncerty';

/**
 * Zwraca listę koncertów dla wybranego zakresu ("upcoming" albo "archive").
 *
 * Startuje od listy wbudowanej w stronę przy buildzie, a po zamontowaniu
 * dociąga aktualną wersję z API sklepu. Dzięki temu dodanie koncertu w panelu
 * jest widoczne od razu, bez przebudowywania strony.
 *
 * Jeśli API nie odpowie, zostaje lista z builda — strona nigdy nie jest pusta.
 */
export default function useKoncerty(zakres, listaZBuilda) {
  const [koncerty, setKoncerty] = useState(listaZBuilda || []);
  const [wczytywanie, setWczytywanie] = useState(true);

  useEffect(() => {
    let aktualne = true;

    setWczytywanie(true);

    fetch(KONCERTY_API_URL + '?scope=' + zakres)
      .then(odpowiedz => {
        if (!odpowiedz.ok) {
          throw new Error('HTTP ' + odpowiedz.status);
        }

        return odpowiedz.json();
      })
      .then(dane => {
        if (aktualne && Array.isArray(dane[zakres])) {
          setKoncerty(dane[zakres]);
        }
      })
      .catch(blad => {
        // Świadomie po cichu — użytkownik widzi listę z builda.
        console.warn('Nie udało się pobrać aktualnej listy koncertów.', blad);
      })
      .then(() => {
        if (aktualne) {
          setWczytywanie(false);
        }
      });

    return () => {
      aktualne = false;
    };
  }, [zakres]);

  return { koncerty, wczytywanie };
}
